import React from 'react';

const CONTOUR_TYPES = ['Grave', 'Arrow', 'GraveCrossSection', 'Scale', 'Ceramic', 'StoneTool'];
const CONTOUR_STROKE = '#3F51B5';
const CONTOUR_FILL = 'rgba(63, 81, 181, 0.5)';
const BOX_STROKE = 'red';
const HIGHLIGHT_STROKE = '#F44336';

const toPoint = ([x, y]) => `${x},${y}`;
const boxCorners = ({ x1, y1, x2, y2 }) => [
  [x1, y1],
  [x2, y1],
  [x2, y2],
  [x1, y2]
];

export default function FigurePreview({ figures = [], image, showContours, onFigureClick, highlightIds = [] }) {
  if (!image) {
    return <div className="alert alert-danger">No page image found.</div>;
  }

  return (
    <div className="figure-preview">
      <svg
        width={image.width}
        height={image.height}
        viewBox={`0 0 ${image.width} ${image.height}`}
        className="figure-preview-svg"
      >
        <image width={image.width} height={image.height} href={image.src || image.href} />
        {figures.map((figure) => (
          <FigureShape
            key={figure.id}
            figure={figure}
            showContours={showContours}
            onFigureClick={onFigureClick}
            highlighted={highlightIds.includes(figure.id)}
          />
        ))}
      </svg>
    </div>
  );
}

function FigureShape({ figure, showContours, onFigureClick, highlighted }) {
  if (figure.type === 'Spine') return null;

  const points = shapePoints(figure, showContours);
  const baseStroke = points ? CONTOUR_STROKE : BOX_STROKE;
  const stroke = highlighted ? HIGHLIGHT_STROKE : baseStroke;
  const clickable = Boolean(onFigureClick);

  return (
    <g
      className={clickable ? 'figure-preview-clickable' : undefined}
      onClick={clickable ? (e) => { e.stopPropagation(); onFigureClick(figure); } : undefined}
    >
      {points ? (
        <polyline points={points} fill={CONTOUR_FILL} stroke={stroke} strokeWidth={highlighted ? 7 : 5} />
      ) : (
        <rect
          fill="none"
          stroke={stroke}
          strokeWidth={highlighted ? 4 : 2}
          x={figure.x1}
          y={figure.y1}
          width={figure.x2 - figure.x1}
          height={figure.y2 - figure.y1}
        />
      )}
      <text x={figure.x1} y={figure.y1} className="figure-preview-label" fill={stroke}>
        {figure.type} {figure.id}
      </text>
    </g>
  );
}

// Returns the polygon for a figure, or null when it is drawn as a box.
function shapePoints(figure, showContours) {
  if (figure.manualBoundingBox) {
    return (figure.manualContour || boxCorners(figure)).map(toPoint).join(' ');
  }

  const showContour =
    showContours && CONTOUR_TYPES.includes(figure.__typename) && figure.contourInfo?.length > 2;
  if (!showContour) return null;

  const points = figure.contourInfo.map(([x, y]) => [x + figure.x1, y + figure.y1]);
  return [...points, points[0]].map(toPoint).join(' ');
}
